var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.handleResize),expression:"handleResize"}],staticClass:"mb-15"},[_vm._t("scrollableContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }